// Formatador de data 
export const formatDate = (dateString) => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR') + ' - ' +
      date.toLocaleTimeString('pt-BR');
  } catch (error) {
    return dateString;
  }
};

// Formatador para o status da infração
export const formatStatus = (status) => {
  const statusMap = {
    'pending': 'Pendente',
    'confirmed': 'Confirmada',
    'rejected': 'Rejeitada'
  };

  return statusMap[status] || status;
};

// Tradução de classes de infrações enviadas pelo agente
export const INFRACTION_CLASS_LABELS = {
  'no_helmet': 'Sem Capacete',
  'no_seatbelt': 'Sem Cinto de Segurança',
  'no_rearview': 'Sem Retrovisor',
  'no_hand': 'Sem Mãos no Guidão',
  'infraction_ontruck': 'Pessoa na Caçamba',
  'cellphone_infraction': 'Uso de Celular',
  'WRONG_WAY': 'Contramão',
  'sandals_infraction': 'Uso de Chinelo',
};

export const INFRACTION_CLASS_OPTIONS = Object.entries(INFRACTION_CLASS_LABELS)
  .map(([value, label]) => ({ value, label }))
  .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));

export const getInfractionClassLabel = (infractionOrValue) => {
  if (!infractionOrValue) return null;

  if (typeof infractionOrValue === 'object' && infractionOrValue.infraction_class_translated) {
    return infractionOrValue.infraction_class_translated;
  }

  const rawValue = typeof infractionOrValue === 'string'
    ? infractionOrValue
    : infractionOrValue.infraction_class || infractionOrValue.class_name;

  if (!rawValue) return null;
  return INFRACTION_CLASS_LABELS[rawValue] || rawValue;
};

// Determina cor do badge baseado no status
export const getStatusColor = (status) => {
  const colorMap = {
    'pending': 'yellow',
    'confirmed': 'green',
    'rejected': 'red'
  };

  return colorMap[status] || 'gray';
};